import { authorizedApiClient } from "../config";
import type {
  AICreditsResponse,
  AIModelsResponse,
  ModelSurface,
  WorkspaceAISettings,
} from "./aiModels.types";

type WorkspaceArg = { workspace_id: string };

export const getAvailableModels = ({
  workspace_id,
  surface = "agent",
}: WorkspaceArg & { surface?: ModelSurface }) =>
  authorizedApiClient.get<AIModelsResponse>(`/${workspace_id}/ai/models`, {
    params: { surface },
  });

export const getWorkspaceAISettings = ({ workspace_id }: WorkspaceArg) =>
  authorizedApiClient.get<WorkspaceAISettings>(`/${workspace_id}/ai-settings`);

export const updateWorkspaceAISettings = ({
  workspace_id,
  payload,
}: WorkspaceArg & { payload: Partial<WorkspaceAISettings> }) =>
  authorizedApiClient.put<WorkspaceAISettings>(
    `/${workspace_id}/ai-settings`,
    payload,
  );

export const getAICredits = ({ workspace_id }: WorkspaceArg) =>
  authorizedApiClient.get<AICreditsResponse>(`/${workspace_id}/ai/credits`);
